/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_ad_go_pro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go Pro — Remove all ads`)
};

const es_f1_ad_go_pro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hazte Pro — Elimina todos los anuncios`)
};

const de_f1_ad_go_pro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro werden — Alle Werbung entfernen`)
};

const nl_f1_ad_go_pro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga Pro — Verwijder alle advertenties`)
};

const fr_f1_ad_go_pro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer Pro — Supprimez toutes les pubs`)
};

const it_f1_ad_go_pro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa a Pro — Rimuovi tutte le pubblicità`)
};

const pt_br2_f1_ad_go_pro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir Pro — Remover todos os anúncios`)
};

const pt_f1_ad_go_pro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torne-se Pro — Remova todos os anúncios`)
};

const ja_f1_ad_go_pro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proにアップグレード — すべての広告を削除`)
};

const zh_f1_ad_go_pro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级Pro — 移除所有广告`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_ad_go_pro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_ad_go_pro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_ad_go_pro", locale)
	if (locale === "en") return en_f1_ad_go_pro(inputs)
	if (locale === "es") return es_f1_ad_go_pro(inputs)
	if (locale === "de") return de_f1_ad_go_pro(inputs)
	if (locale === "nl") return nl_f1_ad_go_pro(inputs)
	if (locale === "fr") return fr_f1_ad_go_pro(inputs)
	if (locale === "it") return it_f1_ad_go_pro(inputs)
	if (locale === "pt-BR") return pt_br2_f1_ad_go_pro(inputs)
	if (locale === "pt") return pt_f1_ad_go_pro(inputs)
	if (locale === "ja") return ja_f1_ad_go_pro(inputs)
	return zh_f1_ad_go_pro(inputs)
};